export const version = "ethers/5.6.3";
//# sourceMappingURL=_version.js.map